import BaseService from '../BaseService';
import OrderTempWorkerProposalApiAgency from '@/api/OrderTempWorkerProposalApiAgency';
import OrderTempWorkerProposalApiTempWorker from '@/api/OrderTempWorkerProposalApiTempWorker';

class OrderTempWorkerProposalService extends BaseService {
	async updateAsync (...args: Parameters<typeof OrderTempWorkerProposalApiTempWorker.update>) {
		if (this.self.isTempWorker()) {
			const { data } = await OrderTempWorkerProposalApiTempWorker.update(...args);
			return data;
		}
	}

	async reminderAsync (...args: Parameters<typeof OrderTempWorkerProposalApiAgency.reminder>) {
		if (this.self.isAgency()) {
			const { data } = await OrderTempWorkerProposalApiAgency.reminder(...args);
			return data;
		}
	}

	async countWaitingAsync (...args: Parameters<typeof OrderTempWorkerProposalApiTempWorker.countWaiting>) {
		if (this.self.isTempWorker()) {
			const { data } = await OrderTempWorkerProposalApiTempWorker.countWaiting(...args);
			return data;
		}
		return 0;
	}

	async getDetailedAsync (...args: Parameters<typeof OrderTempWorkerProposalApiTempWorker.getDetailed>) {
		if (this.self.isTempWorker()) {
			const { data } = await OrderTempWorkerProposalApiTempWorker.getDetailed(...args);
			return data;
		}
	}
}

const orderTempWorkerProposalServiceSingleton = new OrderTempWorkerProposalService();

export default function useOrderTempWorkerProposalService () {
	return orderTempWorkerProposalServiceSingleton;
}
